import React from 'react';
import { LazyRender } from '@noths/polaris-client-ribbons-design-system';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import type { RecommendedProductsProps } from 'src/components/organisms/RecommendedProducts/RecommendedProducts';
import { RecommendedProducts } from 'src/components/organisms/RecommendedProducts/RecommendedProducts';
import * as styles from './ProductCarouselRecommendationsSection.style';

const RECOMMENDED_PRODUCTS_LAZY_LOAD_MARGIN = '200px';

export interface ProductCarouselRecommendationsSectionProps extends RecommendedProductsProps {
  currency: CurrencyCode;
  trackingPosition: number;
  trackingTitle: string;
}

export const ProductCarouselRecommendationsSection = ({
  currency,
  enableFreeDomesticDeliveryLabels,
  servingConfig,
  trackingPosition,
  trackingTitle,
}: ProductCarouselRecommendationsSectionProps) => {
  return (
    <SectionContainer columnsXL={10} maxWidth="max" wrapperStyles={styles.wrapper}>
      <LazyRender
        options={{
          rootMargin: RECOMMENDED_PRODUCTS_LAZY_LOAD_MARGIN,
        }}
      >
        <RecommendedProducts
          currency={currency}
          enableFreeDomesticDeliveryLabels={enableFreeDomesticDeliveryLabels}
          servingConfig={servingConfig}
          trackingPosition={trackingPosition}
          trackingTitle={trackingTitle}
        />
      </LazyRender>
    </SectionContainer>
  );
};
